import { AbstractControl, ValidatorFn } from '@angular/forms';
import moment from 'moment';
export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value ? control.value : '';
    if (!value) {
      return null;
    }
    const isValidDate = moment(value).isValid();
    return isValidDate ? null : { invalidDate: { value: control.value } };
  };
}
